<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "OsobaGrupaStatusaBase"
};
</script>

<style scoped>

</style>
